import { Avatar, AvatarFallback, AvatarImage } from 'components/ui/avatar';
import { PhotoTint } from 'components/ui/photo-tint';
import { CaregiverIdentity } from 'hooks/useCaregivers';
import * as React from 'react';

export function initialsOf(name: string) {
  return name
    .split(/[\s.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0].toUpperCase())
    .join('');
}

/** A caregiver's photo, or her initials while there is none (Figma "Avatar Placeholder"). */
export default function CaregiverAvatar({
  caregiver,
  tinted = false,
  ...props
}: {
  caregiver: CaregiverIdentity;
  /** Her photo warmed with the pink tint (`PhotoTint`). */
  tinted?: boolean;
} & React.ComponentProps<typeof Avatar>) {
  return (
    <Avatar {...props}>
      {caregiver.photoUrl && <AvatarImage src={caregiver.photoUrl} alt="" />}
      <AvatarFallback>{initialsOf(caregiver.name)}</AvatarFallback>
      {tinted && caregiver.photoUrl && <PhotoTint />}
    </Avatar>
  );
}
